import React, { useEffect, useMemo, useRef, useState } from "react";
import "./PerformanceDashboard.css";
import Menubar from "../Menubar";
import { store } from "../../App";
import * as Yup from "yup";
import KpiService from "../../Services/KpiService";
import { AiOutlineSearch } from "react-icons/ai";
import { useFormik } from "formik";
import { downloadUrl, upload_url } from "../../Services/Configuration";
import { FaAward, FaDownload, FaFlag, FaMedal, FaStar } from "react-icons/fa";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import CriteriaPerformanceduplicate from "./CriteriaPerformance";
import { FaChartBar } from "react-icons/fa";
import "../../Components/Report.css";
import { Alert, Container } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer, Cell, } from "recharts";


const CriteriaScorecardReport = () => {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const printRef = useRef();
  const [printData, setPrintData] = useState(null);
  const [printScoreObj, setPrintScoreObj] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState({});
  const [barData, setBarData] = useState([]);
  const [hideData, setHideData] = useState(true);
  const [descTime, setDescTime] = useState("");
  const [economicRemarks, setEconomicRemarks] = useState("");
  const [socialRemarks, setSocialRemarks] = useState("");
  const [governanceRemarks, setGovernanceRemarks] = useState("");
  const [showApproveSection, setShowApproveSection] = useState(false);
  const [selectedApprovalItem, setSelectedApprovalItem] = useState(null);

  const [forwardedDateTime, setForwardedDateTime] = useState("");
  const [approvedDateTime, setApprovedDateTime] = useState("");

  const [approvalDashboardData, setApprovalDashboardData] = useState(null);
  const [forwardtimeStamp, setForwardtimeStamp] = useState("");
  const [approvedtimeStamp, setApprovedtimeStamp] = useState("");

  // Sections are stored/sent to the API as one string using these tags, since the
  // backend only accepts a single criteriaRemarks field.
  const SECTION_REMARK_TAGS = {
    economic: "[ECONOMIC]",
    social: "[SOCIAL]",
    governance: "[GOVERNANCE]",
  };

  const buildCombinedRemarks = (economic, social, governance) =>
    `${SECTION_REMARK_TAGS.economic} ${economic || ""}\n${SECTION_REMARK_TAGS.social} ${social || ""}\n${SECTION_REMARK_TAGS.governance} ${governance || ""}`;

  const parseCombinedRemarks = (combined) => {
    const text = combined || "";

    const extract = (tag, nextTags) => {
      const start = text.indexOf(tag);
      if (start === -1) return "";
      const afterTag = start + tag.length;
      let end = text.length;
      nextTags.forEach((nt) => {
        const idx = text.indexOf(nt, afterTag);
        if (idx !== -1 && idx < end) end = idx;
      });
      return text.slice(afterTag, end).trim();
    };

    const hasTags =
      text.includes(SECTION_REMARK_TAGS.economic) ||
      text.includes(SECTION_REMARK_TAGS.social) ||
      text.includes(SECTION_REMARK_TAGS.governance);

    if (!hasTags) {
      // legacy single remarks saved before section-wise remarks existed
      return { economic: text.trim(), social: "", governance: "" };
    }

    return {
      economic: extract(SECTION_REMARK_TAGS.economic, [SECTION_REMARK_TAGS.social, SECTION_REMARK_TAGS.governance]),
      social: extract(SECTION_REMARK_TAGS.social, [SECTION_REMARK_TAGS.governance]),
      governance: extract(SECTION_REMARK_TAGS.governance, []),
    };
  };

  const getSectionRemarks = (remarkEntry, indicatorData = []) => {
    const parsedRemarks = parseCombinedRemarks(remarkEntry?.remarks || "");
    const fields = String(remarkEntry?.status || "").trim().toUpperCase() === "APPROVED"
      ? ["approved_remarks", "forwarded_remarks"]
      : ["forwarded_remarks"];

    const getIndicatorRemark = (type) => fields.map((field) =>
      indicatorData.find((indicator) =>
        String(indicator?.cs_indicator_type || "").trim().toLowerCase() === type &&
        String(indicator?.[field] || "").trim()
      )?.[field] || ""
    ).find(Boolean) || "";

    return {
      economic: parsedRemarks.economic || getIndicatorRemark("economic"),
      social: parsedRemarks.social || getIndicatorRemark("social"),
      governance: parsedRemarks.governance || getIndicatorRemark("governance"),
    };
  };

  const resetSectionRemarks = () => {
    setEconomicRemarks("");
    setSocialRemarks("");
    setGovernanceRemarks("");
  };



  const reportStyles = {
    page: { padding: "3px 0px", fontFamily: "Arial, Helvetica, sans-serif", background: "#fff" },
    headerRow: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 },
    scoreBox: {
      width: 110, height: 110, borderRadius: 18, background: "#052a5a", color: "#fff", display: "flex",
      alignItems: "center", justifyContent: "center", fontSize: 42, fontWeight: 800,
    },
    grades: { display: "flex", gap: 14, flex: 1, justifyContent: "center", alignItems: "stretch" },
    gradeColumn: { display: "flex", flexDirection: "column", width: 320, borderRadius: 4, overflow: "hidden" },
    gradeHeader: (bg) => ({ background: bg, padding: "10px 6px", textAlign: "center", fontWeight: 800 }),
    gradeMiddle: { padding: "10px 6px", textAlign: "center", fontSize: 26, fontWeight: 800 },
    gradeBottom: { padding: "10px 6px", textAlign: "center", fontWeight: 800 },
    rightBox: {
      width: 110, height: 110, borderRadius: 18, background: "#052a5a", color: "#fff",
      display: "flex", alignItems: "center", justifyContent: "center", fontSize: 36, fontWeight: 800,
    },
    table: { width: "100%", borderCollapse: "collapse", marginTop: 12 },
    th: { border: "1px solid", padding: 8, fontWeight: 800, textAlign: "left" },
    td: { border: "1px solid #efc9b9", padding: 8, verticalAlign: "top" },
    sectionLabel: { width: 72, display: "flex", alignItems: "stretch", justifyContent: "center", marginRight: 12 },
    sectionLabelText: {
      width: 44, height: "100%", minHeight: "100%", alignSelf: "stretch", background: "#f8e1d8", padding: "6px 8px",
      borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center",
    },
    sectionLabelInner: { display: "inline-block", transform: "rotate(-90deg)", transformOrigin: "center", fontWeight: 800, whiteSpace: "nowrap" },
  };
  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white", wordBreak: "break-word" };
  const modernStyles = {
    page: { padding: 20, background: "#F5F7FA" },
    heroCard: { background: "#fff", borderRadius: 16, padding: 20, textAlign: "center", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", marginBottom: 20 },
    kpiContainer: { display: "flex", gap: 16, marginBottom: 20 },
    kpiCard: (bg) => ({ flex: 1, background: bg, borderRadius: 12, padding: 16, textAlign: "center", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }),
    sectionCard: { background: "#fff", borderRadius: 12, padding: "5px 0px", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" },
    table: { width: "100%", borderCollapse: "collapse" },
    th: { color: "#000 !important", padding: 10, textAlign: "left" },
    td: { padding: "8px 8px", fontSize: "14px", fontWeight: "600", verticalAlign: "middle" },
    badge: (item) => ({ padding: "4px 10px", borderRadius: 10, fontWeight: "bold", background: item.color_code || "", color: "#000" }),
  };

  const [scoresData, setScoresData] = useState([]);
  const [searchIndicatorData, setSearchIndicatorData] = useState("");
  const [generatedTime, setGeneratedTime] = useState("");
  useEffect(() => {
    setGeneratedTime(getCurrentDateTime());
  }, []);
  let username = localStorage.getItem("username");
  let districtid = localStorage.getItem("districtid");
  let role = localStorage.getItem("role");
  let mandalid = localStorage.getItem("mandalid");
  const [monthOptions, setMonthOptions] = useState([]);

  const validationSchema = Yup.object({});
  const formik = useFormik({
    initialValues: { category: "", year: "", month: "", type: "", ecoRemarks: "", socRemarks: "", govRemarks: "" },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      await fetchData();
    },
  });

  const scoreForMonth = formik.values.category === "month" ? formik.values.month || "0" : formik.values.category === "provisional" || formik.values.category === "annual" ? "3" : "0";
  const scoreCatId = formik.values.category === "month" ? "Monthly" : formik.values.category === "provisional" ? "Provisionally" : formik.values.category === "annual" ? "Annually" : "Monthly";
  const categoryOptions = [{ value: "month", label: "Month" }, { value: "provisional", label: "Provisional" }, { value: "annual", label: "Annual" },];

  const getMaxYear = () => {
    const years = ["2026-27", "2025-26"];

    return years
      .filter(Boolean)
      .sort((a, b) => {
        const yearA = Number(a.split("-")[0]);
        const yearB = Number(b.split("-")[0]);
        return yearB - yearA;
      })[0] || "";
  };

  const fetchMonths = async () => {
    try {
      const params = { userId: username, year: formik.values.year, type: "CRITERISDASHBOARD" };
      const response = await KpiService.monthNameFromMonthCode(params);
      if (response?.data?.SCODE === "01" && response.data.dataList) {
        const months = response.data.dataList.map((month) => ({
          value: month.month_code, label: month.month_name,
        }));
        setMonthOptions(months);
        // const firstMonth = months?.[0]?.value?.toString() || "";
        // formik.setFieldValue("month", firstMonth);
        const maxMonth = months.length
          ? [...months].sort(
            (a, b) => Number(b.value) - Number(a.value)
          )[0]?.value?.toString() || ""
          : "";

        formik.setFieldValue("month", maxMonth);
      } else { setMonthOptions([]); }
    } catch (error) {
      console.error("Error fetching months:", error);
      setMonthOptions([]);
    }
  };


  useEffect(() => {
    if (formik.values.year) { fetchMonths(); }
    else { setMonthOptions([]); formik.setFieldValue("month", ""); }
  }, [formik.values.year]);

  useEffect(() => {
    if (monthOptions.length > 0) {

      // MAX MONTH
      const maxMonth = [...monthOptions].sort(
        (a, b) => Number(b.value) - Number(a.value)
      )[0]?.value;

      if (!formik.values.month) {
        formik.setFieldValue("month", maxMonth);
      }

      if (
        formik.values.type &&
        formik.values.category &&
        formik.values.year &&
        (formik.values.category !== "month" || maxMonth)
      ) {
        return;
      } else {
        showAlertMessage(
          "Please select all required fields",
          "warning"
        );
      }
    }
  }, [monthOptions]);

  useEffect(() => {
    const { type, category, year, month } = formik.values;

    if (!type || !category || !year || !month) {
      return;
    }

    fetchData();
  }, [formik.values.month]);

  const fetchData = async () => {
    setSearchIndicatorData("");
    const params = {
      userId: username,
      year: formik.values.year,
      scoreForMonth,
      scoreCatId,
      type: formik.values.type === "dist" ? "dist" : formik.values.type === "const" ? "const" : "mandal",
      districtId: role === "2" || role === "64" || role === "65" || role === "73" ? districtid : "0"
    };

    if (role === "65" || role === "73") { params.accode = localStorage.getItem("assemblyid"); }

    const barparams = { userId: username, year: formik.values.year, districtId: "0", scoreCatId, scoreForMonth, type: formik.values.type, };

    const descparams = { "userId": username, "year": formik.values.year, scoreCatId, scoreForMonth, "dashboardType": "CRITERISDASHBOARD" }

    try {
      store.dispatch({ type: "SHOW_SPINNER" });

      // const res = await KpiService.criteriaPerformanceDashboardScoreCardReport(params);

      const res = role === "2" || role === "64" || role === "65" || role === "73" ? await KpiService.criteriaPerformanceDashboardScoreCardDistMandal(params) :
        await KpiService.criteriaPerformanceDashboardScoreCardReport(params);



      const scode = String(res?.data?.SCODE || "");
      if (!res?.data) return;

      if (scode === "02") {
        showAlertMessage("Data not available", "warning");
        setScoresData([]);
        setShowTable(true);
        return;
      }
      if (scode === "01" && Array.isArray(res?.data?.SDESC)) {
        setScoresData(res.data.SDESC);
        setShowTable(true);
      } else {
        setScoresData([]);
      }

    } catch (error) {
      console.error(error);
      setScoresData([]);
      setBarData([]);

    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };


  const prepareScoreRingsForPdf = (cloned) => {
    const rings = cloned.querySelectorAll(".score-ring");

    rings.forEach((svg) => {
      const circles = svg.querySelectorAll("circle");

      if (circles.length < 2) return;

      // Get score from SVG text
      const text = svg.querySelector("text");
      const value = Number(text?.textContent?.trim()) || 0;

      // Get color from the colored SVG circle
      const color = circles[1]?.getAttribute("stroke") || "#3DD9FF";
      const clampedValue = Math.max(0, Math.min(100, value));

      const outerSize = 96;
      const ringWidth = 9;
      const innerSize = outerSize - ringWidth * 2;

      const ring = document.createElement("div");

      ring.style.width = `${outerSize}px`;
      ring.style.height = `${outerSize}px`;
      ring.style.borderRadius = "50%";
      ring.style.background = `
            conic-gradient(
                from 0deg,
                ${color} 0deg ${clampedValue * 3.6}deg,
                #e9edf1 ${clampedValue * 3.6}deg 360deg
            )
        `;

      ring.style.display = "flex";
      ring.style.alignItems = "center";
      ring.style.justifyContent = "center";
      ring.style.flexShrink = "0";

      // Inner white circle
      const inner = document.createElement("div");

      inner.style.width = `${innerSize}px`;
      inner.style.height = `${innerSize}px`;
      inner.style.borderRadius = "50%";
      inner.style.background = "#fff";
      inner.style.display = "flex";
      inner.style.alignItems = "center";
      inner.style.justifyContent = "center";

      inner.style.fontFamily = "Arial, Helvetica, sans-serif";

      inner.style.fontSize = "32px";
      inner.style.fontWeight = "800";
      inner.style.color = color;

      inner.textContent = clampedValue;

      ring.appendChild(inner);

      svg.parentNode.replaceChild(ring, svg);
    });
  };

  // html2canvas cannot rasterize conic-gradients or inline SVG rings, so draw them on a canvas instead screen
  const prepareScoreRingsForCanvasPdf = (cloned) => {
    const rings = cloned.querySelectorAll(".score-ring");

    rings.forEach((svg) => {
      const circles = svg.querySelectorAll("circle");
      if (circles.length < 2) return;

      const text = svg.querySelector("text");
      const value = Math.max(0, Math.min(100, Number(text?.textContent?.trim()) || 0));
      const color = circles[1]?.getAttribute("stroke") || "#3DD9FF";

      const size = 24;
      const stroke = 2;
      const scale = 3;

      const canvas = document.createElement("canvas");
      canvas.width = size * scale;
      canvas.height = size * scale;
      canvas.style.width = `${size}px`;
      canvas.style.height = `${size}px`;
      canvas.style.flexShrink = "0";

      const ctx = canvas.getContext("2d");
      ctx.scale(scale, scale);

      const center = size / 2;
      const radius = (size - stroke) / 2;

      ctx.lineWidth = stroke;
      ctx.strokeStyle = "#e9edf1";
      ctx.beginPath();
      ctx.arc(center, center, radius, 0, Math.PI * 2);
      ctx.stroke();

      if (value > 0) {
        ctx.strokeStyle = color;
        ctx.lineCap = "round";
        ctx.beginPath();
        ctx.arc(center, center, radius, -Math.PI / 2, -Math.PI / 2 + (value / 100) * Math.PI * 2);
        ctx.stroke();
      }

      ctx.fillStyle = color;
      ctx.font = "800 7px Arial, Helvetica, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(String(value), center, center);

      svg.parentNode.replaceChild(canvas, svg);
    });
  };
  //added
  const prepareBarChartForPdf = (cloned, chartSvgMarkup) => {
    const chart = cloned.querySelector(".approval-bar-chart");
    if (!chart || !chartSvgMarkup) return;

    const chartHeight = Math.max(180, Math.min(280, barData.length * 9 + 200));
    const chartDocument = new DOMParser().parseFromString(chartSvgMarkup, "image/svg+xml");
    const chartSvg = chartDocument.documentElement;
    const fontScale = 1.5;

    chartSvg.querySelectorAll("text").forEach((text) => {
      text.setAttribute("font-family", "Arial, sans-serif");
      const fontSize = Number.parseFloat(text.getAttribute("font-size"));
      if (Number.isFinite(fontSize)) {
        text.setAttribute("font-size", `${fontSize * fontScale}`);
      }

      const style = text.getAttribute("style");
      if (style?.includes("font-size")) {
        text.setAttribute(
          "style",
          style.replace(/font-size\s*:\s*([\d.]+)px/g, (_, size) => `font-size:${Number(size) * fontScale}px`)
        );
      }
    });

    chart.replaceChildren();
    chart.style.width = "180mm";
    chart.style.maxWidth = "180mm";
    chart.style.height = `${chartHeight}mm`;
    chart.style.boxSizing = "border-box";
    chart.style.overflow = "visible";

    const image = document.createElement("img");
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(chartSvg))}`;
    image.style.display = "block";
    image.style.width = "100%";
    image.style.height = "100%";
    image.style.objectFit = "fill";
    image.style.maxWidth = "none";
    chart.appendChild(image);
  };

  // cloned textareas only carry their initial value, so read the live ones by index
  const removeEmptyRemarkBlocks = (cloned) => {
    const liveTextareas = printRef.current
      ? Array.from(printRef.current.querySelectorAll("textarea"))
      : [];

    Array.from(cloned.querySelectorAll("textarea")).forEach((textarea, index) => {
      const value = (liveTextareas[index]?.value ?? textarea.value ?? "").trim();

      if (!value) {
        const block = textarea.parentElement || textarea;
        block.remove();
        return;
      }

      textarea.value = value;
      textarea.textContent = value;
    });
  };

  const appendWorkflowSignatures = (cloned, signatureData = {}, forceApproved = false) => {
    console.log("Signature Data:", signatureData);
    console.log("Forward Time Stamp:", forwardtimeStamp);
    const reportType = formik.values.type;
    const hasForwarded = signatureData.hasForwarded || signatureData.hasApproved;
    const hasApproved = signatureData.hasApproved || forceApproved;

    if (!hasForwarded && !hasApproved) return;

    const signatureContainer = document.createElement("div");
    signatureContainer.className = "approval-signatures";
    signatureContainer.style.display = "flex";
    signatureContainer.style.justifyContent = "space-between";
    signatureContainer.style.alignItems = "flex-start";
    signatureContainer.style.marginTop = "30px";
    signatureContainer.style.padding = "0 20px";
    signatureContainer.style.fontFamily = "Arial, Helvetica, sans-serif";
    signatureContainer.style.fontSize = "14px";
    signatureContainer.style.lineHeight = "1.6";
    signatureContainer.style.pageBreakInside = "avoid";
    signatureContainer.style.breakInside = "avoid";

    if (hasForwarded) {
      const validationSignature = document.createElement("div");
      validationSignature.style.width = "45%";
      validationSignature.style.textAlign = "left";

      if (reportType === "dist") {
        validationSignature.innerHTML = `
          <div style="font-weight:700;font-size:15px;margin-bottom:4px;">Validated by: Chief Planning Officer (CPO)</div>
          <div>District: ${signatureData.district_name || "-"}</div>
          <div>Date &amp; Time: ${forwardtimeStamp || getCurrentDateTime()}</div>
        `;
      } else if (reportType === "const") {
        validationSignature.innerHTML = `
          <div style="font-weight:700;font-size:15px;margin-bottom:4px;">Validated by: CVAPU ${signatureData.acname || "-"}</div>
          <div>Constituency: ${signatureData.acname || "-"}</div>
          <div>Date &amp; Time: ${forwardtimeStamp || getCurrentDateTime()}</div>
        `;
      } else {
        validationSignature.innerHTML = `
          <div style="font-weight:700;font-size:15px;margin-bottom:4px;">Validated by: Assistant Statistical Officer (ASO)</div>
          <div>Mandal: ${signatureData.mandal_name || "-"}</div>
          <div>Date &amp; Time: ${forwardtimeStamp || getCurrentDateTime()}</div>
        `;
      }

      signatureContainer.appendChild(validationSignature);
    }

    if (hasApproved) {
      const approvalSignature = document.createElement("div");
      approvalSignature.style.width = "45%";
      approvalSignature.style.textAlign = "right";
      approvalSignature.style.marginLeft = hasForwarded ? "0" : "auto";

      if (reportType === "dist") {
        approvalSignature.innerHTML = `
          <div style="font-weight:700;font-size:15px;margin-bottom:4px;">Approved by: District Collector</div>
          <div>District: ${signatureData.district_name || "-"}</div>
          <div>Date &amp; Time: ${signatureData.approvedDate || getCurrentDateTime()}</div>
        `;
      } else if (reportType === "const") {
        approvalSignature.innerHTML = `
          <div style="font-weight:700;font-size:15px;margin-bottom:4px;">Approved by: Constituency Special Officer</div>
          <div>Constituency: ${signatureData.acname || "-"}</div>
          <div>Date &amp; Time: ${signatureData.approvedDate || getCurrentDateTime()}</div>
        `;
      } else {
        approvalSignature.innerHTML = `
          <div style="font-weight:700;font-size:15px;margin-bottom:4px;">Approved by: Chief Planning Officer (CPO)</div>
          <div>District: ${signatureData.district_name || "-"}</div>
          <div>Date &amp; Time: ${signatureData.approvedDate || getCurrentDateTime()}</div>
        `;
      }

      signatureContainer.appendChild(approvalSignature);
    }

    cloned.appendChild(signatureContainer);
  };

  const generatePDF = async (fileData, signatureData) => {
    const element = printRef.current;
    if (!element) return;

    // Clone printable content
    const cloned = element.cloneNode(true);

    const approvalBarChart = cloned.querySelector(".approval-bar-chart");
    if (approvalBarChart) {
      approvalBarChart.style.pageBreakBefore = "auto";
      approvalBarChart.style.breakBefore = "auto";
      approvalBarChart.style.pageBreakAfter = "auto";
      approvalBarChart.style.breakAfter = "auto";
      approvalBarChart.style.pageBreakInside = "avoid";
      approvalBarChart.style.breakInside = "avoid";
    }

    removeEmptyRemarkBlocks(cloned);
    prepareScoreRingsForPdf(cloned);
    appendWorkflowSignatures(cloned, signatureData);


    const categoryLabel =
      categoryOptions.find((opt) => opt.value === formik.values.category)?.label ||
      "Report";

    const currentMonthLabel =
      monthOptions.find((m) => String(m.value) === String(scoreForMonth))?.label ||
      "";


    const sanitizeFileNamePart = (value) => {
      return String(value || "")
        .trim()
        .replace(/\./g, "_")                 // IMPORTANT: replace dots
        .replace(/\s+/g, "_")                // spaces -> _
        .replace(/[\\/:*?"<>|]/g, "")        // invalid filename characters
        .replace(/_+/g, "_")                 // remove duplicate underscores

    };

    let locationName = "";

    if (formik.values.type === "dist") {
      const districtName = sanitizeFileNamePart(
        fileData?.district_name ||
        displayScoreObj?.district_name ||
        "District"
      );

      locationName = `${districtName}_District`;

    } else if (formik.values.type === "mandal") {
      const districtName = sanitizeFileNamePart(
        fileData?.district_name ||
        displayScoreObj?.district_name ||
        "District"
      );

      const mandalName = sanitizeFileNamePart(
        fileData?.mandal_name ||
        displayScoreObj?.mandal_name ||
        "Mandal"
      );

      locationName = `${districtName}_${mandalName}_Mandal`;

    } else {
      const constituencyName = sanitizeFileNamePart(
        fileData?.acname ||
        displayScoreObj?.acname ||
        "Constituency"
      );

      locationName = `${constituencyName}_Constituency`;
    }
    // let locationName = "";

    // if (formik.values.type === "dist") {
    //   locationName = `${fileData?.district_name ||
    //     displayScoreObj?.district_name ||
    //     "District"
    //     }_District`;
    // } else if (formik.values.type === "mandal") {
    //   locationName = `${fileData?.district_name ||
    //     displayScoreObj?.district_name ||
    //     "District"
    //     }_${fileData?.mandal_name ||
    //     displayScoreObj?.mandal_name ||
    //     "Mandal"
    //     }_Mandal`;
    // } else {
    //   locationName = `${fileData?.acname ||
    //     displayScoreObj?.acname ||
    //     "Constituency"
    //     }_Constituency`;
    // }

    const finalFileName = [
      locationName,
      categoryLabel,
      formik.values.category === "month" ? currentMonthLabel : "",
      selectedYear,
      "Report",
    ]
      .filter(Boolean)
      .join("_")
      .replace(/\s+/g, "_")
      .replace(/[\\/:*?"<>|]/g, "");


    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.left = "-10000px";
    iframe.style.top = "0";
    iframe.style.width = "100vw";
    iframe.style.height = "100vh";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    const styles = Array.from(
      document.querySelectorAll('link[rel="stylesheet"],style')
    )
      .map((s) => s.outerHTML)
      .join("");

    doc.open();

    doc.write(`
<!DOCTYPE html>
<html>

<head>

<meta charset="utf-8">



${styles}

<style>

@page{
    size:tabloid landscape;
    margin:0mm;
}

html,
body{
    margin:0;
    padding:0;
    background:#fff;
    overflow:visible !important;
    -webkit-print-color-adjust:exact !important;
    print-color-adjust:exact !important;
}

body{
    zoom:100%;
}

table{
    width:100%;
    border-collapse:collapse;
}

thead{
    display:table-header-group;
}

tfoot{
    display:table-footer-group;
}

tr,
td,
th{
    page-break-inside:avoid;
    break-inside:avoid;
}

img {
    max-width:100%;
    height:auto;
}



</style>

</head>

<body>

<div id="report-container">

${cloned.outerHTML}

</div>

</body>

</html>
`);

    doc.close();

    iframe.onload = () => {
      const images = iframe.contentDocument.images;

      Promise.all(
        Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();

          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        })
      ).then(() => {
        setTimeout(() => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();

          iframe.contentWindow.onafterprint = () => {
            iframe.remove();
          };
        }, 500);
      });
    };
  };

  const indicatorList = printData?.indicatorData || [];
  const hasEconomic = indicatorList.some((it) => it.cs_indicator_type === "Economic");
  const hasSocial = indicatorList.some((it) => it.cs_indicator_type === "Social");
  const hasGovernance = indicatorList.some((it) => it.cs_indicator_type === "Governance");







  const renderPrintSection = (type, data) => {
    const getHeaderColor = () => {
      if (type === "Economic") return "#a9560a";
      if (type === "Social") return "#276712";
      if (type === "Governance") return "#052A6B";
      return "#eee";
    };
    const getBodyColor = () => {
      if (type === "Economic") return "rgb(229 218 206)";
      if (type === "Social") return "rgb(214 255 217)";
      if (type === "Governance") return "#cae0ff";
      return "#eee";
    };

    const headerColor = getHeaderColor();
    const bodyColor = getBodyColor();

    const formatZeroWhenAvgDash = (v, avg) => {
      const avgIsDash = avg === null || avg === undefined || String(avg) === "-" || String(avg) === "";
      if (v === null || v === undefined) return "-";
      const n = Number(v);
      if (isNaN(n)) return "-";
      if (n === 0 && avgIsDash) return "-";
      return n.toLocaleString("en-IN");
    };

    const filtered = data?.filter((d) => d.cs_indicator_type === type);
    const isEconomic = type === "Economic";
    const isSocial = type === "Social";
    const isGovernance = type === "Governance";
    const districtId = filtered?.[0]?.district_id;

    const subsectorGroups = {};
    for (let i = 0; i < (data?.length || 0); i++) {
      const name = data[i]?.sector || "";
      if (i === 0 || name !== (data[i - 1]?.sector || "")) {
        let j = i + 1;
        while (j < data.length && (data[j]?.sector || "") === name) j++;
        subsectorGroups[i] = j - i; // length of group starting at i
      }
    }

    const showNature = isSocial || isGovernance;
    const showYtd = isEconomic;
    const baseColCount = 10; // SNo, Indicator, Unit, Reporting Period, Annual Target, Target For Reporting Period, Achievement, Score, Grade, State Score
    const colCount = baseColCount + (showNature ? 1 : 0) + (showYtd ? 1 : 0);


    if (!filtered || filtered.length === 0) return null;
    return (
      <div className="sectionCard" style={{ pageBreakInside: "auto", breakInside: "auto" }}>

        <table className="report-table econ-table">
          <thead>
            <tr>
              <th style={{ width: "4%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> S.No </th>
              <th style={{ width: "20%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Indicator </th>
              <th style={{ width: "6%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Unit </th>
              {!isEconomic && (
                <th style={{ width: "6%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Nature </th>
              )}
              <th style={{ width: "8%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Period </th>
              <th style={{ width: "9%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Annual Target (FY{selectedYear}) </th>
              <th style={{ width: "10%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Proportionate Target </th>
              <th style={{ width: "15%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Cumulative Achievement</th>
              {/* <th style={{ width: "10%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Growth over Previous Period(%)</th> */}
              {isEconomic && (
                <th style={{ width: "12%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> YTD Growth (%) </th>
              )}
              <th style={{ width: "8%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Score </th>
              <th style={{ width: "8%", background: headerColor, color: "#fff", border: "1px solid #d49a7a" }}> Grade </th>
              <th className="custom-th-black th-no-wrap" style={{ background: headerColor, color: "#fff", border: "1px solid #d49a7a", textAlign: "center", }} > {formik.values.type === "dist" ? "State Score" : "District Score"} </th>

            </tr>
          </thead>


          <tbody>
            {filtered.map((item, i) => {
              const showSubSector = i === 0 || filtered[i - 1]?.sector !== item.sector;

              return (
                <React.Fragment key={i}>
                  {/* Sub-Sector Row */}
                  {isEconomic && showSubSector && (
                    <tr>
                      <td colSpan={colCount} style={{ background: "#f7efe6", fontWeight: "bold", textAlign: "center", padding: "8px 12px", fontSize: "15px", }} > {item.sector} </td>
                    </tr>
                  )}

                  {/* Indicator Row */}
                  <tr style={{ pageBreakInside: "avoid", breakInside: "avoid", }} >
                    <td>{i + 1}</td>

                    <td style={{ textAlign: "left" }}> {item.cs_indicator_name || "-"} </td>

                    <td> {item.unit || "-"} </td>
                    {!isEconomic && <td> {item.indicator_nature || "-"} </td>}

                    <td> {item.periodic_name || "-"} </td>
                    <td style={{ textAlign: "right" }}> {item.target != null && item.target !== "" ? Number(item.target).toLocaleString("en-IN") : "-"} </td>

                    <td style={{ textAlign: "right" }}>{formatZeroWhenAvgDash(item.current_cycle_target, item.averagescore)}</td>
                    <td style={{ textAlign: "right" }}>{formatZeroWhenAvgDash(item.achivementvalue, item.averagescore)}</td>
                    {/* <td>{item.cur_pre_growth || "-"}</td> */}
                    {isEconomic && (
                      <td style={{ textAlign: "right" }}>
                        {Number(item?.ytd_growth_rate ?? "-") < 0 ? (
                          <span> <span style={{ color: "#000" }}>{item.ytd_growth_rate || "-"}</span> <span style={{ color: "red", marginLeft: "4px" }}> ▼ </span> </span>
                        ) : (item?.ytd_growth_rate ?? "-")} </td>
                    )}
                    <td className="td-no-wrap" style={{ textAlign: "right" }}> {item.averagescore === null ? "-" : item.averagescore ?? "-"} </td>                    <td className="td-no-wrap" style={{ textAlign: "right" }}> {item.grade || "-"} </td>
                    <td className="td-no-wrap score-font" style={{ textAlign: "right", background: bodyColor, color: "#000", }}> {" "} {item.state_district_score ?? "-"}{" "} </td></tr>
                </React.Fragment>
              );
            })} </tbody> </table> </div>);
  };

  const getBarColor = (grade) => {
    if (grade === "A+") return "#9ED286";
    if (grade === "A") return "#FFCD1E";
    if (grade === "B") return "#3DD9FF";
    if (grade === "C") return "#FF6E74";
    return "#ccc";
  };

  const computeStats = (type) => {
    const indicators = (printData?.indicatorData || []).filter((d) => d.cs_indicator_type === type);
    const vals = indicators.map((i) => Number(i?.averagescore)).filter((v) => !isNaN(v));
    const total = indicators.length || 0;
    const avg = vals.length ? vals.reduce((a, b) => a + b, 0) / vals.length : null;
    const max = vals.length ? Math.max(...vals) : null;
    const min = vals.length ? Math.min(...vals) : null;
    const activeIndicators = indicators.filter((i) => i?.averagescore != null && i?.averagescore !== "" && !isNaN(Number(i?.averagescore))).length;
    const inactiveIndicators = total - activeIndicators;
    return { total, avg, max, min, activeIndicators, inactiveIndicators };
  };



  const filteredData = useMemo(() => {
    if (!searchIndicatorData) return scoresData;

    const q = searchIndicatorData.toLowerCase();

    return scoresData?.filter((item) =>
      (item?.district_name || "").toLowerCase().includes(q) ||
      (item?.mandal_name || "").toLowerCase().includes(q) ||
      (item?.acname || "").toLowerCase().includes(q) ||
      (item?.score_cat_id || "").toLowerCase().includes(q)
    );
  }, [scoresData, searchIndicatorData]);


  const selectedYear = formik?.values?.year || "";
  const getCurrentDateTime = () => {
    const now = new Date(); const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); const year = String(now.getFullYear()).slice(-2);
    const hours = String(now.getHours()).padStart(2, "0"); const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0"); return `${day}/${month}/${year},${hours}:${minutes}:${seconds}`;
  };
  const scoreObj = scoresData.find((d) => String(d.district_id) === String(districtid) && String(d.mandal_id) === String(mandalid)) || {};

  const displayScoreObj = printScoreObj || scoreObj;

  const monthLabel = monthOptions.find((m) => String(m.value) === String(displayScoreObj?.score_for_month))?.label || (displayScoreObj?.score_for_month ? monthOptions[displayScoreObj.score_for_month - 1]?.label : "") || "";



  const handleDownload = async (item) => {
    store.dispatch({ type: "SHOW_SPINNER" });

    try {

      // Get Access Token
      const tokenRes = await KpiService.getFilesUploadToken();

      const token = tokenRes?.data;

      if (!token) {
        throw new Error("Unable to fetch access token.");
      }

      // Download File
      const response = await KpiService.downloadCriteriaFile(item.file_path, token);

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      // Open PDF in new tab
      window.open(pdfUrl, "_blank");

      // Don't revoke immediately because new tab needs the blob
      setTimeout(() => {
        window.URL.revokeObjectURL(pdfUrl);
      }, 60000);


      // const url = window.URL.createObjectURL(response.data);

      // const link = document.createElement("a");
      // link.href = url;

      // const downloadName = item.file_path.split("/").pop();
      // link.download = downloadName;

      // document.body.appendChild(link);
      // link.click();

      // document.body.removeChild(link);
      // window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download Error:", error);
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const handlePrint = async (item) => {
    // openPrintWindow(item);
    setSelectedFileData(item);
    const params = {
      userId: username,
      scoreForMonth,
      scoreCatId,
      year: formik.values.year,
      districtId: formik.values.type !== "const" ? item.district_id || item.district_code : "0",
      mandalId: formik.values.type === "mandal" ? item?.mandal_id : "0",
      type: formik.values.type === "dist" ? "dist" : formik.values.type === "const" ? "const" : "mandal",
      accode: formik.values.type === "const" ? item?.accode : "0",
    };




    const barparams = {
      userId: username,
      year: formik.values.year,
      scoreCatId,
      scoreForMonth,

      districtId: formik.values.type === "dist" ? "0" : item?.district_id || "0",

      type:
        formik.values.type === "dist"
          ? "dist"
          : formik.values.type === "const"
            ? "const"
            : "mandal",

      accode:
        formik.values.type === "const"
          ? item?.accode || "0"
          : "0",
    };

    const descparams = { "userId": username, "year": formik.values.year, scoreCatId, scoreForMonth, "dashboardType": "CRITERISDASHBOARD" }


    try {
      store.dispatch({ type: "SHOW_SPINNER" });

      const res = await KpiService.criteriaPerformanceDashboardScoreCard(params);
      // const barres = await KpiService.criteriaPerformanceDashboardGraphScoreCard( barparams );
      const barres = formik.values.type !== "const" ? await KpiService.criteriaPerformanceDashboardGraphScoreCard(barparams) : null;
      const descres = await KpiService.dashboardDisplaysDateWise(descparams);

      if (res?.data) {
        const remarkData = res.data?.remarkData || [];

        const approvedRemark = remarkData.find((r) => String(r?.status || "").trim().toUpperCase() === "APPROVED");
        const forwardedRemark = remarkData.find((r) => String(r?.status || "").trim().toUpperCase() === "FORWARDED");

        const hasApproved = !!approvedRemark;
        const hasForwarded = !!forwardedRemark;

        const printForwardedDate = forwardedRemark?.entered_on || "";
        const printApprovedDate = approvedRemark?.entered_on || "";
        setForwardtimeStamp(printForwardedDate);
        setApprovedtimeStamp(printApprovedDate);


        const printRemarkEntry = approvedRemark || forwardedRemark || {};
        const printRemarks = printRemarkEntry.remarks || "";
        const sectionRemarks = getSectionRemarks(printRemarkEntry, res.data.indicatorData || []);

        const data = {
          scoreData: res.data.scoreData || [],
          criteriaData: res.data.criteriaData || [],
          indicatorData: res.data.indicatorData || [],
          // remarks: res.data?.remarkData?.[0]?.remarks || "",
          remarks: printRemarks,
          eco_remarks: sectionRemarks.economic,
          soc_remarks: sectionRemarks.social,
          gov_remarks: sectionRemarks.governance,
          ytd_growth_rate: res.data?.ytd_growth_rate || "",
          indicator_nature: res.data?.indicator_nature || "",
        };
        setPrintData(data);
        const printScoreObjData = {

          district_name: item?.district_name || scoreObj?.district_name || "",
          mandal_name: item?.mandal_name || scoreObj?.mandal_name || "",
          score_for_month: data.scoreData?.[0]?.score_for_month || scoreForMonth,
          district_id: item?.district_code || districtid,
          mandal_id: item?.mandal_id || mandalid,
          averagescore: item?.averagescore || "",
          grade: item?.grade || "",
          acname: item?.acname || "",

          hasForwarded,
          hasApproved,

          forwardedDate: printForwardedDate,
          approvedDate: printApprovedDate,
        };
        setPrintScoreObj(printScoreObjData);
        setTimeout(async () => {
          await generatePDF(item, printScoreObjData);
        }, 500);
      }

      if (formik.values.type !== "const" && barres?.data?.SCODE === "01") {
        const dataList = barres.data.scoreData || [];

        const finalData = dataList
          .filter((item) => {
            if (formik.values.type === "dist") {
              return (
                item.district_id != null &&
                item.district_name != null &&
                String(item.district_name).trim() !== ""
              );
            }

            // if (formik.values.type === "const") {
            //     return (
            //         item.accode != null &&
            //         item.acname != null &&
            //         String(item.acname).trim() !== ""
            //     );
            // }

            // mandal
            return (
              item.mandal_id != null &&
              item.mandal_name != null &&
              String(item.mandal_name).trim() !== ""
            );
          })
          .map((item) => {
            if (formik.values.type === "dist") {
              return {
                district_id: item.district_id,
                district_code: item.district_code,
                district_name: item.district_name,

                average_score: Number(item.averagescore) || 0,

                grade: item.grade,
                color_code: item.color_code,
                noofindicators: item.noofindicators,
              };
            }

            // if (formik.values.type === "const") {
            //     return {
            //         district_id: item.accode,
            //         district_code: item.accode,
            //         district_name: item.acname,

            //         average_score: Number(item.averagescore) || 0,

            //         grade: item.grade,
            //         color_code: item.color_code,
            //         noofindicators: item.noofindicators,
            //     };
            // }

            // mandal
            return {
              district_id: item.mandal_id,
              district_code: item.mandal_code,
              district_name: item.mandal_name,

              average_score: Number(item.averagescore) || 0,


              grade: item.grade,
              color_code: item.color_code,
              noofindicators: item.noofindicators,
            };
          }).sort((a, b) => b.average_score - a.average_score);


        setBarData(finalData);
      }
      else { setBarData([]); }
      if (descres?.data?.SCODE === "01") {
        setDescTime(descres?.data?.dataList[0]?.insert_time);
      } else {
        setDescTime("")
      }
    } catch (error) {
      console.error(error);
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };


  function ScoreRing({ value, color }) {
    const size = 96; const stroke = 9; const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r; const offset = c - (value / 100) * c;
    return (
      <svg className="score-ring" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e9edf1" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r}
          fill="none" stroke={color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`} />
        <text x="50%" y="50%" dominantBaseline="central" textAnchor="middle" className="score-ring-text" fill={color}>
          {value} </text> </svg>);
  }

  function SemiGauge({ label, color }) {
    const pct = parseFloat(label) || 0; const w = 120; const h = 62; const r = 50; const cx = w / 2;
    const cy = h; const start = { x: cx - r, y: cy }; const end = { x: cx + r, y: cy };
    const clamped = Math.max(0, Math.min(100, pct)); const theta = Math.PI * (1 - clamped / 100);
    const px = cx + r * Math.cos(theta); const py = cy - r * Math.sin(theta); const large = clamped > 50 ? 1 : 0;
    return (
      <svg className="semi-gauge" width={w} height={h + 4} viewBox={`0 0 ${w} ${h + 4}`}>
        <path d={`M ${start.x} ${start.y} A ${r} ${r} 0 0 1 ${end.x} ${end.y}`} fill="none" stroke="#e9edf1" strokeWidth="9" strokeLinecap="round" />
        <path d={`M ${start.x} ${start.y} A ${r} ${r} 0  ${large} 1 ${px} ${py}`} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round" />
        <text x={cx} y={cy - 6} textAnchor="middle" className="semi-gauge-text" fill="#1d2733">
          {label} </text> </svg>);
  }

  function SummaryStrip({ summary, accent, gaugeColor }) {
    return (
      <div className="summary-strip">
        <div className="summary-block summary-basic">
          <div className="sb-item">
            <span className="sb-label"> Score</span>
            <span className="sb-value" style={{ color: accent }}>{summary.averageScore}</span>
          </div>
          <div className="sb-item">
            <span className="sb-label">Total Indicators</span>
            <span className="sb-value" style={{ color: accent }}>{summary.totalIndicators}</span>
          </div>

          <div className="sb-item">
            <span className="sb-label">Active Indicators</span>
            <span className="sb-value" style={{ color: accent }}>{summary.activeIndicators}</span>
          </div>
          <div className="sb-item">
            <span className="sb-label">Inactive Indicators</span>
            <span className="sb-value" style={{ color: accent }}>{summary.inactiveIndicators}</span>
          </div>
        </div>

        <div className="summary-block summary-targets">
          <div className="st-item">
            <span className="st-label">Achiever</span>
            <span className="st-value" style={{ color: "#1f8a34" }}>{summary.onTarget.value}</span>
            {/* <MiniBar pct={summary.onTarget.pct} color="#1f8a34" /> */}
            <span className="st-pct">A+ Grade</span>
          </div>
          <div className="st-item">
            <span className="st-label">Front Runner</span>
            <span className="st-value" style={{ color: "#1f8a34" }}>{summary.aboveTarget.value}</span>
            <span className="st-pct">A Grade</span>
          </div>
          <div className="st-item">
            <span className="st-label">Performer</span>
            <span className="st-value" style={{ color: "#f07d00" }}>{summary.belowTarget.value}</span>
            <span className="st-pct">B Grade</span>
          </div>
          <div className="st-item">
            <span className="st-label">Aspirant</span>
            <span className="st-value" style={{ color: "#e03131" }}>{summary.aspTarget.value}</span>
            <span className="st-pct">C Grade</span>
          </div>
        </div>

        <div className="summary-block summary-gauge">
          <span className="sg-label">Average Achievements</span>
          <SemiGauge label={summary.averageAchievements} color={gaugeColor} />
        </div>
      </div>
    );
  }



  const handleApprove = async () => {
    if (!selectedApprovalItem) {
      showAlertMessage("Approval data not found", "error");
      return;
    }

    setSearchIndicatorData("");

    try {
      store.dispatch({ type: "SHOW_SPINNER" });

      // -----------------------------------------
      // 2. Get selected item details
      // -----------------------------------------
      const item = selectedApprovalItem;
      const approvalStatus = String(item?.status || "").trim().toUpperCase();

      const currentScoreForMonth =
        item?.score_for_month || scoreForMonth;

      const currentScoreCatId =
        item?.score_cat_id || scoreCatId;

      const currentYear =
        formik.values.year;

      // -----------------------------------------
      // 3. Make sure report data is available
      // -----------------------------------------
      let approvalPrintData = printData;
      let approvalPrintScoreObj = printScoreObj;


      if (!approvalPrintData) {

        const reportParams = {
          userId: username,
          scoreForMonth: currentScoreForMonth,
          scoreCatId: currentScoreCatId,
          year: currentYear,

          districtId:
            formik.values.type !== "const"
              ? item?.district_id || item?.district_code || "0"
              : "0",

          mandalId:
            formik.values.type === "mandal"
              ? item?.mandal_id || "0"
              : "0",

          type:
            formik.values.type === "dist"
              ? "dist"
              : formik.values.type === "const"
                ? "const"
                : "mandal",

          accode:
            formik.values.type === "const"
              ? item?.accode || "0"
              : "0",
        };

        const reportRes =
          await KpiService.criteriaPerformanceDashboardScoreCard(
            reportParams
          );

        if (!reportRes?.data) {
          showAlertMessage(
            "Report data not found",
            "error"
          );
          return;
        }

        const remarkData = reportRes.data?.remarkData || [];

        const approvedRemark = remarkData.find((r) => String(r?.status || "").trim().toUpperCase() === "APPROVED");

        const forwardedRemark = remarkData.find((r) => String(r?.status || "").trim().toUpperCase() === "FORWARDED");

        const printRemarkEntry = approvedRemark || forwardedRemark || {};
        const printRemarks = printRemarkEntry.remarks || "";
        const sectionRemarks = getSectionRemarks(printRemarkEntry, reportRes.data.indicatorData || []);

        approvalPrintData = {
          scoreData: reportRes.data.scoreData || [],
          criteriaData: reportRes.data.criteriaData || [],
          indicatorData: reportRes.data.indicatorData || [],
          // remarks: reportRes.data?.remarkData?.[0]?.remarks || "",
          remarks: printRemarks,
          eco_remarks: sectionRemarks.economic,
          soc_remarks: sectionRemarks.social,
          gov_remarks: sectionRemarks.governance,
          ytd_growth_rate:
            reportRes.data?.ytd_growth_rate || "",
          indicator_nature:
            reportRes.data?.indicator_nature || "",
        };

        approvalPrintScoreObj = {
          district_name:
            item?.district_name ||
            scoreObj?.district_name ||
            "",

          mandal_name:
            item?.mandal_name ||
            scoreObj?.mandal_name ||
            "",

          score_for_month:
            approvalPrintData.scoreData?.[0]?.score_for_month ||
            currentScoreForMonth,

          district_id:
            item?.district_id ||
            item?.district_code ||
            districtid,

          mandal_id:
            item?.mandal_id ||
            mandalid,

          averagescore:
            item?.averagescore || "",

          grade:
            item?.grade || "",

          acname:
            item?.acname || "",
        };

        // Store them also in state if required elsewhere
        setPrintData(approvalPrintData);
        setPrintScoreObj(approvalPrintScoreObj);
      }

      // -----------------------------------------
      // 4. Generate PDF
      // -----------------------------------------
      const element = printRef.current;

      if (!element) {
        showAlertMessage(
          "Report content not found",
          "error"
        );
        return;
      }

      const cloned = element.cloneNode(true);
      const liveChartSvg = element.querySelector(".approval-bar-chart svg");
      const chartSvgMarkup = liveChartSvg
        ? new XMLSerializer().serializeToString(liveChartSvg)
        : "";


      //server file css
      // cloned.style.width = "755px";
      // cloned.style.minWidth = "755px";
      // cloned.style.maxWidth = "none";

      cloned.style.width = "194mm";
      cloned.style.minWidth = "194mm";
      cloned.style.maxWidth = "194mm";
      cloned.style.boxSizing = "border-box";

      const portraitExportStyles = document.createElement("style");
      portraitExportStyles.textContent = `
          .top-grid { height: auto !important; min-height: 40mm !important; max-height: none !important; gap: 5px !important; margin-bottom: 8px !important; overflow: visible !important; align-items: start !important; }
          .district-card { padding: 8px 11px !important; overflow: hidden !important; }
          .dc-sub { font-size: 9px !important; }
          .dc-title { font-size: 19px !important; margin: 3px 0 !important; }
          .dc-period { font-size: 10px !important; }
          .score-card { width: 100% !important; height: 32mm !important; min-height: 32mm !important; aspect-ratio: 1 / 1 !important; align-self: start !important; padding: 3px !important; gap: 2px !important; overflow: visible !important; box-sizing: border-box !important; }
          .score-label { font-size: 7px !important; }
          .score-ring { width: 24px !important; height: 24px !important; }
          .score-ring-text { font-size: 3px !important; }
          .score-grade-label, .score-grade-badge { font-size: 11px !important; }
          .score-grade-badge { padding: 3px 7px !important; }
          .section-head { padding: 7px 8px 0 !important; gap: 6px !important; flex-wrap: wrap !important; }
          .section-head-title { min-width: 0 !important; flex: 0 0 100% !important; gap: 6px !important; padding-bottom: 0 !important; }
          .section-icon { width: 28px !important; height: 28px !important; }
          .section-icon img { width: 16px !important; height: 16px !important; }
          .sh-name { font-size: 14px !important; }
          .sh-desc { font-size: 9px !important; }
          .summary-strip { display: grid !important; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important; flex: 0 0 100% !important; min-width: 0 !important; gap: 5px !important; margin-bottom: 7px !important; }
          .summary-basic, .summary-targets { width: auto !important; min-width: 0 !important; }
          .summary-basic { gap: 4px !important; padding: 7px !important; }
          .summary-targets { padding: 7px !important; }
          .sb-label, .st-label { font-size: 7px !important; }
          .sb-value, .st-value { font-size: 10px !important; }
          .st-pct { font-size: 6px !important; }
          .report-table thead th { padding: 7px 5px !important; font-size: 7px !important; }
          .report-table tbody td { padding: 7px 5px !important; font-size: 7px !important; }
          .report-table tbody tr td { line-height: 1.3 !important; }
          .report-table { width: 100% !important; page-break-inside: auto !important; break-inside: auto !important; }
          .report-table thead { display: table-header-group !important; }
          .report-table tbody { display: table-row-group !important; }
          .report-table tbody tr { page-break-inside: avoid !important; break-inside: avoid !important; }
          .score-font { font-size: 12px !important; }
          .approval-bar-chart { width: 100% !important; overflow: visible !important; }
          .approval-bar-chart .recharts-responsive-container { width: 100% !important; }
        `;
      cloned.prepend(portraitExportStyles);
      //server file css

      const approvalBarChart = cloned.querySelector(".approval-bar-chart");
      if (approvalBarChart) {
        approvalBarChart.style.pageBreakBefore = "auto";
        approvalBarChart.style.breakBefore = "auto";
        approvalBarChart.style.pageBreakAfter = "auto";
        approvalBarChart.style.breakAfter = "auto";
        approvalBarChart.style.pageBreakInside = "avoid";
        approvalBarChart.style.breakInside = "avoid";
      }

      // Convert score rings
      prepareScoreRingsForCanvasPdf(cloned);
      prepareBarChartForPdf(cloned, chartSvgMarkup);

      // -----------------------------------------
      // 5. Remove overflow restrictions
      // -----------------------------------------
      cloned
        .querySelectorAll("[style*='overflow']")
        .forEach((el) => {
          el.style.height = "auto";
          el.style.overflow = "visible";
        });

      // -----------------------------------------
      // 6. Convert textarea to printable div
      // -----------------------------------------
      removeEmptyRemarkBlocks(cloned);

      cloned
        .querySelectorAll("textarea")
        .forEach((textarea) => {
          const div = document.createElement("div");

          div.innerText = textarea.value || "";

          div.style.whiteSpace = "pre-wrap";
          div.style.fontSize = "16px";
          div.style.padding = "10px";
          div.style.border = "2px solid #999";

          textarea.parentNode.replaceChild(
            div,
            textarea
          );
        });

      const approvalDisclaimer = cloned.querySelector(".approval-disclaimer");
      if (approvalDisclaimer) {
        approvalDisclaimer.style.pageBreakBefore = "avoid";
        approvalDisclaimer.style.breakBefore = "avoid-page";
        approvalDisclaimer.style.pageBreakInside = "avoid";
        approvalDisclaimer.style.breakInside = "avoid";
      }

      appendWorkflowSignatures(
        cloned,
        {
          ...approvalPrintScoreObj,
          hasForwarded: approvalStatus === "FORWARDED",
          hasApproved: true,
          approvedDate: getCurrentDateTime(),
        }
      );

      const approvalSignatures = cloned.querySelector(".approval-signatures");
      if (approvalSignatures) {
        approvalSignatures.style.pageBreakBefore = "avoid";
        approvalSignatures.style.breakBefore = "avoid-page";
        approvalSignatures.style.pageBreakInside = "avoid";
        approvalSignatures.style.breakInside = "avoid";
      }


      const sanitizeFileNamePart = (value = "") => {
        return String(value)
          .trim()
          .replace(/\./g, "_")              // IMPORTANT: remove dots
          .replace(/\s+/g, "_")             // spaces -> _
          .replace(/[\\/:*?"<>|]/g, "")     // invalid characters
          .replace(/_+/g, "_")              // duplicate underscores

      };




      // const mandalName = approvalPrintScoreObj?.mandal_name || "";
      const mandalName = sanitizeFileNamePart(approvalPrintScoreObj?.mandal_name || "Mandal");

      // -----------------------------------------
      // 9. PDF options (approval screen)
      // -----------------------------------------
      const pdfOptions = {
        margin: [8, 8, 8, 8],

        image: {
          type: "jpeg",
          quality: 1,
        },

        html2canvas: {
          scale: 2,
          useCORS: true,
          scrollY: 0,
        },

        jsPDF: {
          unit: "mm",
          format: "a4",
          // orientation: "landscape",
          orientation: "portrait",
        },

        pagebreak: {
          mode: ["css", "legacy"],
          avoid: ["tr"],
        },
      };

      // -----------------------------------------
      // 10. Generate PDF
      // -----------------------------------------
      const html2pdf =
        (await import("html2pdf.js")).default;

      const worker =
        html2pdf()
          .set(pdfOptions)
          .from(cloned);

      const pdf =
        await worker
          .toPdf()
          .get("pdf");

      const pdfBlob =
        pdf.output("blob");

      // -----------------------------------------
      // 11. Create file name
      // -----------------------------------------



      const locationName = sanitizeFileNamePart(approvalPrintScoreObj?.district_name || "District");



      const monthName = sanitizeFileNamePart(
        monthOptions.find(
          (m) =>
            String(m.value) ===
            String(currentScoreForMonth)
        )?.label || ""
      );

      const safeYear = sanitizeFileNamePart(currentYear);

      const fileName =
        `${locationName}_${mandalName}_${monthName}_${safeYear}_Month_Report.pdf`;



      // const monthName =
      //     monthOptions.find(
      //         (m) =>
      //             String(m.value) ===
      //             String(currentScoreForMonth)
      //     )?.label || "";

      // const fileName =
      //     `${locationName}_${mandalName}_${monthName}_${currentYear}_Month_Report.pdf`;

      // -----------------------------------------
      // 12. Sanitize filename
      // -----------------------------------------
      const sanitizeFileName = (name = "") => {
        let result = "";
        let prevUnderscore = false;

        for (const ch of name) {

          const isAllowed =
            (ch >= "a" && ch <= "z") ||
            (ch >= "A" && ch <= "Z") ||
            (ch >= "0" && ch <= "9") ||
            ch === "." ||
            ch === "_" ||
            ch === "-";

          if (isAllowed) {
            result += ch;
            prevUnderscore = false;
          } else if (!prevUnderscore) {
            result += "_";
            prevUnderscore = true;
          }
        }

        let start = 0;
        let end = result.length;

        while (
          start < end &&
          result[start] === "_"
        ) {
          start++;
        }

        while (
          end > start &&
          result[end - 1] === "_"
        ) {
          end--;
        }

        return result.slice(start, end);
      };

      const safeFileName =
        sanitizeFileName(fileName) ||
        "report.pdf";

      // -----------------------------------------
      // 13. Validate filename
      // -----------------------------------------
      if (
        !/^[A-Za-z0-9._-]+$/.test(
          safeFileName
        )
      ) {
        showAlertMessage(
          "Invalid filename. Only letters, numbers, dot, underscore and hyphen are allowed",
          "warning"
        );
        return;
      }

      // -----------------------------------------
      // 14. Prepare FormData
      // -----------------------------------------
      const formData = new FormData();

      formData.append(
        "file",
        pdfBlob,
        safeFileName
      );

      // -----------------------------------------
      // 15. Get upload token
      // -----------------------------------------
      const loginRes =
        await KpiService.getFilesUploadToken();

      const uploadToken =
        loginRes?.data;

      if (!uploadToken) {
        showAlertMessage(
          "Unable to get upload token",
          "error"
        );
        return;
      }

      // -----------------------------------------
      // 16. Upload PDF
      // -----------------------------------------
      const uploadRes =
        await KpiService.CriteriaperformanceUploadfiles(
          formData,
          uploadToken
        );

      const filePath = uploadRes?.data;

      if (!filePath) { showAlertMessage("File upload failed", "error"); return; }
      const uploadedFileName = String(filePath).split("/").pop();

      const fileId = uploadedFileName.split("_")[0].trim();

      console.log("Uploaded File Name:", uploadedFileName);
      console.log("Extracted File ID:", fileId);

      // -----------------------------------------
      // 17. Approval API parameters
      // -----------------------------------------
      const params = {
        userId: username,

        scoreForMonth:
          currentScoreForMonth,

        scoreCatId:
          currentScoreCatId,

        year:
          currentYear,

        type: "mandal",

        districtId:
          item?.district_id ||
          item?.district_code ||
          districtid ||
          "0",

        mandalId:
          item?.mandal_id ||
          mandalid ||
          "0",

        accode: "0",

        // criteriaRemarks: buildCombinedRemarks(economicRemarks, socialRemarks, governanceRemarks),
        ecoRemarks: economicRemarks,
        socRemarks: socialRemarks,
        govRemarks: governanceRemarks,
        fileName: safeFileName,
        filePath: filePath,
        fileId: fileId,
      };

      console.log(
        "APPROVAL PARAMS:",
        params
      );

      // -----------------------------------------
      // 18. Call approval API
      // -----------------------------------------
      const res =
        await KpiService
          .criteriaPerformanceDashboardScoreCardApprove(
            params
          );

      console.log(
        "APPROVAL RESPONSE:",
        res?.data
      );

      const scode =
        String(
          res?.data?.SCODE || ""
        );

      const sdesc =
        res?.data?.SDESC ||
        "No response from server";

      // -----------------------------------------
      // 19. Handle response
      // -----------------------------------------
      if (scode === "01") {

        await showAlertMessage(
          sdesc,
          "success"
        );

        // Close approval popup
        setShowApproveSection(false);
        setSelectedApprovalItem(null);
        resetSectionRemarks();

        // Refresh table
        try {
          await fetchData();
        } catch (e) {
          console.error(
            "fetchData error:",
            e
          );
        }

      } else if (scode === "03") {

        showAlertMessage(
          sdesc,
          "warning"
        );

      } else if (scode === "02") {

        showAlertMessage(
          sdesc,
          "warning"
        );

      } else {

        showAlertMessage(
          sdesc,
          "error"
        );
      }

    } catch (err) {

      console.error(
        "Approval Error:",
        err
      );

      showAlertMessage(
        "Something went wrong.",
        "error"
      );

    } finally {

      store.dispatch({
        type: "HIDE_SPINNER"
      });
    }
  };




  const handleOpenApprovedPdf = async (item) => {
    store.dispatch({ type: "SHOW_SPINNER" });

    try {
      const filePath = item?.file_path || item?.filePath;

      if (!filePath) {
        showAlertMessage("Approved PDF not found", "warning");
        return;
      }

      const fileName = String(filePath).split("/").pop();

      const fileId = fileName.split("_")[0].trim();

      if (!fileName) {
        showAlertMessage("PDF file name not found", "warning");
        return;
      }
      if (!fileId) {
        showAlertMessage("PDF file ID not found", "warning");
        return;
      }


      const tokenRes = await KpiService.getFilesUploadToken();

      const token = tokenRes?.data;


      if (!token) {
        throw new Error("Unable to fetch access token.");
      }

      // // Download PDF with Authorization header
      const response = await KpiService.downloadCriteriaFile(fileName, token);

      // // Convert response to PDF Blob
      // const pdfBlob = new Blob( [response.data], { type: "application/pdf" } );

      // // const pdfUrl = window.URL.createObjectURL(pdfBlob);
      // // const pdfUrl = `${upload_url}CriteriaPerformanceUploadfiles/api/v1/view/${fileId}.pdf`;
      //   const pdfUrl = `${upload_url}CriteriaPerformanceUploadfiles/api/v1/view/${fileId}.pdf?token=${encodeURIComponent(token)}`;


      // // Open PDF in new tab

      // window.open(pdfUrl, "_blank");


      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      // link.download = fileName;
      const downloadName = fileName.split("/").pop();
      link.download = downloadName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);


    } catch (error) {
      console.error("Open Approved PDF Error:", error);
      showAlertMessage(
        "Unable to open approved PDF",
        "error"
      );
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const handleReadyToApprove = async (item) => {
    try {
      setSelectedApprovalItem(item);
      const itemRemarks = getSectionRemarks(item);
      setEconomicRemarks(itemRemarks.economic);
      setSocialRemarks(itemRemarks.social);
      setGovernanceRemarks(itemRemarks.governance);
      setApprovalDashboardData(null);

      store.dispatch({ type: "SHOW_SPINNER" });

      const params = {
        accode: "0",

        districtId: item?.district_id || "0",

        mandalId: item?.mandal_id || "0",

        scoreCatId: item?.score_cat_id || scoreCatId,

        scoreForMonth: item?.score_for_month || scoreForMonth,

        type: "mandal",

        userId: username,

        year: formik.values.year
      };

      console.log("criteriaPerformanceDashboardScoreCard payload:", params);

      const response = await KpiService.criteriaPerformanceDashboardScoreCard(params);

      console.log("criteriaPerformanceDashboardScoreCard response:", response?.data);
      setForwardtimeStamp(response?.data?.remarkData?.find((remark) => String(remark?.status || "").trim().toUpperCase() === "FORWARDED")?.entered_on || "");
      setApprovedtimeStamp(response?.data?.remarkData?.find((remark) => String(remark?.status || "").trim().toUpperCase() === "APPROVED")?.entered_on || "");
      if (!response?.data) {
        showAlertMessage(
          "Unable to fetch approval data",
          "error"
        );
        return;
      }

      const responseData = response.data;

      if (String(responseData?.SCODE) !== "01") {
        showAlertMessage(
          responseData?.SDESC || "Data not available",
          "warning"
        );
        return;
      }

      const remarkData = responseData?.remarkData || [];
      const approvedRemark = remarkData.find((remark) => String(remark?.status || "").trim().toUpperCase() === "APPROVED");
      const forwardedRemark = remarkData.find((remark) => String(remark?.status || "").trim().toUpperCase() === "FORWARDED");
      const responseRemarks = getSectionRemarks(
        approvedRemark || forwardedRemark || remarkData[0],
        responseData?.indicatorData || []
      );
      setEconomicRemarks(responseRemarks.economic);
      setSocialRemarks(responseRemarks.social);
      setGovernanceRemarks(responseRemarks.governance);

      // Store complete API response
      setApprovalDashboardData(responseData);

      // Also store it in printData if you need the same
      // data for PDF/printing
      setPrintData({
        scoreData: responseData?.scoreData || [],
        criteriaData: responseData?.criteriaData || [],
        indicatorData: responseData?.indicatorData || [],
        remarkData: responseData?.remarkData || [],
        ytd_growth_rate:
          responseData?.ytd_growth_rate || "",
        indicator_nature:
          responseData?.indicator_nature || "",
      });

      const approvalScoreCatId = item?.score_cat_id || scoreCatId;
      const approvalScoreForMonth = item?.score_for_month || scoreForMonth;

      // graph + generated-on time so the approval view matches the printed report
      const barres = await KpiService.criteriaPerformanceDashboardGraphScoreCard({
        userId: username,
        year: formik.values.year,
        scoreCatId: approvalScoreCatId,
        scoreForMonth: approvalScoreForMonth,
        districtId: item?.district_id || "0",
        type: "mandal",
        accode: "0",
      });

      if (barres?.data?.SCODE === "01") {
        const finalData = (barres.data.scoreData || [])
          .filter((d) => d.mandal_id != null && d.mandal_name != null && String(d.mandal_name).trim() !== "")
          .map((d) => ({
            district_id: d.mandal_id,
            district_code: d.mandal_code,
            district_name: d.mandal_name,
            average_score: Number(d.averagescore) || 0,
            grade: d.grade,
            color_code: d.color_code,
            noofindicators: d.noofindicators,
          }))
          .sort((a, b) => b.average_score - a.average_score);

        setBarData(finalData);
      } else {
        setBarData([]);
      }

      const descres = await KpiService.dashboardDisplaysDateWise({
        userId: username,
        year: formik.values.year,
        scoreCatId: approvalScoreCatId,
        scoreForMonth: approvalScoreForMonth,
        dashboardType: "CRITERISDASHBOARD",
      });

      setDescTime(
        descres?.data?.SCODE === "01"
          ? descres?.data?.dataList?.[0]?.insert_time || ""
          : ""
      );

      // Store selected score information
      setPrintScoreObj({
        district_name:
          item?.district_name || "",

        mandal_name:
          item?.mandal_name || "",

        district_id:
          item?.district_id ||
          item?.district_code ||
          districtid,

        mandal_id:
          item?.mandal_id ||
          "",

        score_for_month:
          responseData?.scoreData?.[0]?.score_for_month ||
          item?.score_for_month ||
          scoreForMonth,

        averagescore:
          item?.averagescore || "",

        grade:
          item?.grade || "",

        acname:
          item?.acname || "",
      });

      // Finally open Approval section
      setShowApproveSection(true);

    } catch (error) {
      console.error(
        "Error fetching approval dashboard data:",
        error
      );

      showAlertMessage(
        "Unable to fetch approval data",
        "error"
      );
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const isApprovalView = showApproveSection && !!selectedApprovalItem && role === "2";

  const closeApprovalView = () => {
    setShowApproveSection(false);
    setSelectedApprovalItem(null);
    resetSectionRemarks();
  };

  const renderSectionRemarks = (label, value, onChange) => (
    <div style={{ marginTop: 12 }}>
      <label style={{ display: "block", fontWeight: 600, marginBottom: 7 }}>
        <span style={{ fontSize: "16px", marginRight: 6 }}>📝</span>
        {label} Remarks
      </label>

      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={`Enter ${label.toLowerCase()} remarks`}
        rows={3}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          resize: "vertical",
          fontSize: "14px",
          boxSizing: "border-box",
        }}
      />
    </div>
  );

  const renderSavedSectionRemark = (label, value) => {
    if (!value?.trim()) return null;

    return (
      <div style={{ marginTop: 12 }}>
        <div style={{ fontWeight: 600, marginBottom: 7, fontSize: "14px" }}>
          <span style={{ fontSize: "16px", marginRight: 6 }}>📝</span>
          {label} Remarks:
        </div>
        <div
          style={{
            width: "100%",
            minHeight: "44px",
            border: "1px solid #999",
            padding: "10px",
            fontSize: "14px",
            lineHeight: "1.5",
            whiteSpace: "pre-wrap",
            boxSizing: "border-box",
          }}
        >
          {value}
        </div>
      </div>
    );
  };

  const formatStatus = (status = "") => { return String(status).trim().replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()); };

  return (
    <>

      <Menubar />
      <Container fluid className="outer-page-content-container" style={{ background: "#f4f6f9", width: "100%", minHeight: "100vh", padding: 0, }}>
        {/* <Container fluid style={{ width: "96%"}}> */}
        <div
          style={{
            background: "#f4f6f9",
            padding: isApprovalView ? "25px 0 0 0" : "25px 0 60px 0",
            minHeight: isApprovalView ? "auto" : "100vh",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "100%", maxWidth: "90%" }}>
            <div style={{ display: "grid", alignItems: "center", marginBottom: 12 }}>
              <div className="col-12 col-lg-12 col-md-12 col-xl-12 col-xxl-12 col-sm-12 col-xs-12">
                <div className="row g-2 align-items-end sdg-dash flex-nowrap">
                  <>
                    <div className="col-12 col-md-2 d-flex flex-column gap-1">
                      <label className="mb-0">
                        Type <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        name="type"
                        value={formik.values.type}
                        onChange={(e) => {
                          formik.setFieldValue("type", e.target.value);
                          formik.setFieldValue("month", "");
                          formik.setFieldValue("year", "");
                          formik.setFieldValue("category", "");

                          // formik.handleSubmit();
                          setShowTable(false);
                        }}
                      >
                        <option value="">--select--</option>

                        {role !== "2" && role !== "64" && role !== "65" && role !== "73" && (<option value="dist">District</option>)}
                        <option value="mandal">Mandal</option>    {role !== "65" && role !== "73" && (<option value="const">Constituency</option>)}
                      </select>
                    </div>
                    <div className="col-12 col-md-2 d-flex flex-column gap-1">
                      <label className="mb-0">
                        {" "}
                        Score-Cat <span className="text-danger">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        name="category"
                        value={formik.values.category}
                        onChange={(e) => {
                          formik.setFieldValue("category", e.target.value); formik.setFieldValue("year", "");
                          formik.setFieldValue("month", ""); setShowTable(false);
                        }} >
                        <option value="">--select--</option>
                        {categoryOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}> {" "} {opt.label}{" "} </option>
                        ))}{" "} </select>{" "} </div>
                    <div className="col-12 col-md-2 d-flex flex-column gap-1">
                      <label className="mb-0"> {" "} Year <span className="text-danger">*</span>{" "} </label>
                      <select className="form-select" name="year" value={formik.values.year} onChange={(e) => { formik.setFieldValue("year", e.target.value); formik.setFieldValue("month", ""); }} >
                        <option value="">--select--</option> <option value="2026-27">2026-27</option>
                        <option value="2025-26">2025-26</option>{" "}
                      </select>{" "} </div>
                    <div className="col-12 col-md-2 d-flex flex-column gap-1" style={{ visibility: formik.values.category === "month" ? "visible" : "hidden" }}>
                      <label className="mb-0"> {" "} Month <span className="text-danger">*</span>{" "} </label>
                      <select className="form-select" name="month" value={formik.values.month}
                        onChange={(e) => {
                          const month = e.target.value; formik.setFieldValue("month", month);
                          const type = formik.values.type; const category = formik.values.category; const year = formik.values.year;
                          if (!type || !category || !year || !month) {
                            showAlertMessage("Please select all required fields", "warning");
                            setShowTable(false);
                            return;
                          } formik.handleSubmit();
                        }} >
                        <option value="">--select--</option>
                        {monthOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {" "}
                            {opt.label}{" "}
                          </option>
                        ))}
                      </select>{" "}
                    </div>{" "}
                  </>
                  {showTable && (
                    <div className="col-md-6 d-flex justify-content-end">
                      <div className="d-flex align-items-center gap-2 flex-nowrap ms-auto" style={{ marginRight: "160px" }}>
                        {/* SEARCH */}
                        <div className="d-flex align-items-center">
                          <div style={{ background: "#f1f1f1", padding: "6px 8px", border: "1px solid #ccc", borderRight: "none" }}>
                            <AiOutlineSearch />{" "}
                          </div>
                          <input type="text" placeholder="Search" value={searchIndicatorData} onChange={(e) => setSearchIndicatorData(e.target.value)} style={{ padding: "6px", border: "1px solid #ccc", outline: "none", width: "160px" }} />{" "}
                        </div>

                        {generatedTime && (
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#555",
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {generatedTime}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>{" "}
              </div>
            </div>

            {showTable && !isApprovalView && (
              <div
                style={{
                  marginTop: "35px",
                  maxHeight: "450px",
                  overflowY: "auto",
                  border: "1px solid #ddd",
                }}
              >
                <table id="reportTable" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>S.No</th>
                      {formik.values.type !== "const" && !["2", "64"].includes(role) && <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>District</th>}
                      {formik.values.type === "mandal" && <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>Mandal</th>}
                      {formik.values.type === "const" && <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>Constituency</th>}

                      {/* {["2", "64","65","73"].includes(role)&&  */}
                      <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>Score</th>
                      {/* } */}
                      {/* {["2", "64","65","73"].includes(role)&&  */}
                      <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>Grade</th>
                      {/* } */}

                      {formik.values.category === "month" && <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>Score-Cat</th>}

                      <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>File</th>
                      {/* {formik.values.type === "mandal" && role==="2" && <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2 }}>Remarks</th>} */}
                      {/* {formik.values.type === "mandal" && role=== "2" &&  */}
                      <th style={{ ...headerStyle, position: "sticky", top: 0, zIndex: 2, textAlign: "center" }}>Status</th>
                      {/* } */}
                    </tr>
                  </thead>

                  <tbody>
                    {Array.isArray(scoresData) && scoresData.length > 0 ? (
                      filteredData.map((item, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          {formik.values.type !== "const" && !["2", "64"].includes(role) && <td style={{ textAlign: "left" }}>{item.district_name}</td>}

                          {formik.values.type === "mandal" && <td style={{ textAlign: "left" }}>{item.mandal_name}</td>}
                          {formik.values.type === "const" && <td style={{ textAlign: "left" }}>{item.acname}</td>}

                          {/* {["2", "64","65","73"].includes(role)&& */}
                          <td style={{ textAlign: "right" }}>  {String(item.file || "").trim() === "Score has not been generated" ? "-" : item.averagescore ?? "-"}</td>
                          {/* } */}
                          {/* {["2", "64","65","73"].includes(role)&&  */}
                          <td style={{ textAlign: "center" }}>
                            {String(item.file || "").trim() === "Score has not been generated" ? "-" : item.grade ?? "-"}
                          </td>
                          {/* } */}

                          {formik.values.category === "month" && <td style={{ textAlign: "left" }}>{item.score_cat_id}</td>}


                          <td style={{ color: "red" }}>
                            {item.averagescore === null && item.grade === null ? (
                              "Score has not been generated"
                            )

                              : (
                                <button
                                  // onClick={() => handlePrint(item)}
                                  onClick={() => {
                                    const status = String(item?.status || "").trim().toUpperCase();

                                    if (status === "APPROVED" && item?.file_path) {
                                      handleOpenApprovedPdf(item);
                                    } else {
                                      handlePrint(item);
                                    }
                                  }}
                                  style={{
                                    padding: "6px 12px",
                                    backgroundColor: "#007bff",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <FaDownload size={15} />
                                </button>
                              )}
                          </td>

                          <td style={{ textAlign: "center" }}>
                            {formik.values.type === "mandal" && role === "2" ? (
                              String(item.status || "").trim().toUpperCase() === "FORWARDED_TO_CPO" || String(item.status || "").trim().toUpperCase() === "FORWARDED_TO_MPDO" ? (
                                <button
                                  type="button"
                                  onClick={() => handleReadyToApprove(item)}
                                  style={{
                                    color: "#007bff",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    fontSize: "14px",
                                    textDecoration: "none",
                                  }}
                                >
                                  Ready to Approve
                                </button>
                              ) : String(item.status || "").trim().toUpperCase() === "APPROVED" ? (
                                <span
                                  style={{
                                    color: "#287d3c",
                                    backgroundColor: "#f0f8f2",
                                    border: "1px solid #b7dfc0",
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                    display: "inline-block",
                                    letterSpacing: "0.2px",
                                  }}
                                >
                                  ✓ Approved
                                </span>
                              ) : (<span style={{ color: "#666" }}> Not Yet Initiated </span>)
                            ) : (String(item.status || "").trim().toUpperCase() === "APPROVED" ? (
                              <span style={{
                                color: "#287d3c", backgroundColor: "#f0f8f2", border: "1px solid #b7dfc0", padding: "5px 10px", borderRadius: "4px",
                                fontWeight: "600", fontSize: "13px", display: "inline-block", letterSpacing: "0.2px",
                              }} > ✓ Approved </span>) :
                              String(item.status || "").trim().toUpperCase() === "NOT YET INITIATED" ? (<span style={{ color: "#666", fontWeight: "550", }} >
                                {item.status} </span>) : (<span style={{ color: "#007bff" }}> {formatStatus(item.status)}

                                </span>))}
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        {" "}
                        <td colSpan="100%" style={{ textAlign: "center" }}>
                          {" "}
                          No Data Available{" "}
                        </td>{" "}
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div></div>

        <div
          style={
            isApprovalView
              ? {
                width: "90%",
                margin: "0 auto",
                background: "#fff",
                padding: "0 0 24px 0",
              }
              : { position: "absolute", left: "-9999px", top: 0, width: "1200px", background: "#fff" }
          }
        >
          {/* header part in approval screen */}
          {/* {isApprovalView && (
            <div
              style={{
                position: "sticky",
                top: 0,
                zIndex: 3,
                background: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderBottom: "1px solid #ddd",
                padding: "12px 0",
                marginBottom: "12px",
              }}
            >
              <h4 style={{ margin: 0, fontWeight: 600, textAlign: "center", flex: 1,color:"brown" }}>
                Approval&nbsp;-&nbsp;
                {selectedApprovalItem?.mandal_name ||
                  selectedApprovalItem?.district_name ||
                  ""}
              </h4>

              <button
                type="button"
                onClick={closeApprovalView}
                style={{
                  position: "absolute",
                  right: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "none",
                  background: "transparent",
                  fontSize: "26px",
                  cursor: "pointer",
                  color: "#666",
                  lineHeight: 1,
                }}
              >
                &times;
              </button>
            </div>
          )} */}
          <div ref={printRef} style={isApprovalView ? { width: "100%" } : undefined}>
            <div
              className="top-grid"
              style={{
                gridTemplateColumns: "1.35fr 4fr",
                gap: "5px",
                alignItems: "stretch",
                marginBottom: "16px",
              }}
            >
              {/* LEFT : DISTRICT */}
              <div
                className="district-card"
                style={{
                  gridColumn: "1",
                  gridRow: "1",
                  alignSelf: "stretch",
                  height: "auto",
                  minHeight: "100%",
                  boxSizing: "border-box",
                }}
              >
                <img src="../images/dc-bg.png" className="dc-bg" />
                <div className="dc-info">
                  <div className="dc-sub">
                    {formik.values.type === "dist"
                      ? "District"
                      : formik.values.type === "const"
                        ? "Constituency"
                        : "Mandal"}{" "}
                    {scoreCatId} Report
                  </div>

                  <div className="dc-title">
                    {formik.values.type === "dist"
                      ? displayScoreObj?.district_name || ""
                      : formik.values.type === "const"
                        ? displayScoreObj?.acname || ""
                        : displayScoreObj?.mandal_name || ""
                    }
                  </div>

                  <div className="dc-period">
                    ({monthLabel} {selectedYear})
                  </div>
                </div>
              </div>

              {/* RIGHT SIDE */}
              <div
                style={{
                  gridColumn: "2",
                  gridRow: "1",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  minWidth: 0,
                  alignSelf: "stretch",
                  boxSizing: "border-box",
                }}
              >


                {/* SCORE CARDS */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    gap: "16px",
                    minWidth: 0,
                    alignItems: "stretch",
                    boxSizing: "border-box",
                  }}
                >
                  {/* OVERALL */}
                  <div
                    className="score-card"
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      alignSelf: "stretch",
                    }}
                  >
                    <div
                      className="score-label"
                      style={{ color: getBarColor(printData?.scoreData?.[0]?.grade) }}
                    >



                      OVERALL SCORE
                    </div>

                    <ScoreRing
                      value={
                        printData?.scoreData?.[0]?.averagescore || "-"
                      }
                      color={getBarColor(
                        printData?.scoreData?.[0]?.grade
                      )}
                    />

                    <div className="score-grade-row">
                      <span className="score-grade-label">
                        Grade
                      </span>

                      <span
                        className="score-grade-badge"
                        style={{
                          backgroundColor: getBarColor(
                            printData?.scoreData?.[0]?.grade
                          ),
                        }}
                      >
                        {printData?.scoreData?.[0]?.grade || "-"}
                      </span>
                    </div>
                  </div>

                  {/* ECONOMIC */}
                  <div
                    className="score-card"
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      alignSelf: "stretch",
                    }}
                  >
                    <div className="score-label" style={{ color: getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Economic")[0]?.grade) }} > ECONOMIC </div>

                    <ScoreRing value={printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Economic")[0]?.averagescore || "-"}
                      color={getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Economic")[0]?.grade)} />

                    <div className="score-grade-row"> <span className="score-grade-label"> Grade </span>

                      <span className="score-grade-badge"
                        style={{ backgroundColor: getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Economic")[0]?.grade), }} >
                        {printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Economic")[0]?.grade || "-"}
                      </span> </div> </div>

                  {/* SOCIAL */}
                  <div className="score-card" style={{ width: "100%", boxSizing: "border-box", alignSelf: "stretch", }} >
                    <div className="score-label" style={{ color: getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Social")[0]?.grade) }} > SOCIAL </div>

                    <ScoreRing value={printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Social")[0]?.averagescore || "-"}
                      color={getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Social")[0]?.grade)} />

                    <div className="score-grade-row"> <span className="score-grade-label"> Grade </span>

                      <span className="score-grade-badge"
                        style={{ backgroundColor: getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Social")[0]?.grade), }} >
                        {printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Social")[0]?.grade || "-"}
                      </span> </div> </div>

                  {/* GOVERNANCE */}
                  <div className="score-card" style={{ width: "100%", boxSizing: "border-box", alignSelf: "stretch", }} >
                    <div className="score-label" style={{ color: getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Governance")[0]?.grade) }} > GOVERNANCE </div>

                    <ScoreRing value={printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Governance")[0]?.averagescore || "-"}
                      color={getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Governance")[0]?.grade)} />

                    <div className="score-grade-row"> <span className="score-grade-label"> Grade </span>

                      <span className="score-grade-badge"
                        style={{ backgroundColor: getBarColor(printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Governance")[0]?.grade), }} >
                        {printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Governance")[0]?.grade || "-"}
                      </span> </div> </div> </div>

                {/* LEGEND */}
                <div
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid var(--line)",
                    borderRadius: "10px",
                    padding: "6px 5px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    overflow: "hidden",
                    flexShrink: 0,
                  }}
                >
                  {[
                    { color: "#ff5a5a", text: "Aspirant (C) <50%" },
                    { color: "#2fb4ff", text: "Performer (B) 50%-74%" },
                    { color: "#f7c600", text: "Front Runner (A) 75%-89%" },
                    { color: "#6cc04a", text: "Achiever (A+) 90%-100%" },
                  ].map((item) => (
                    <div
                      key={item.text}
                      style={{
                        width: "25%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "3px",
                        whiteSpace: "nowrap",
                        boxSizing: "border-box",
                      }}
                    >
                      <span
                        style={{
                          width: "9px",
                          height: "9px",
                          minWidth: "9px",
                          borderRadius: "50%",
                          backgroundColor: item.color,
                          display: "inline-block",
                        }}
                      />

                      <span
                        style={{
                          fontSize: "9px",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                          lineHeight: "12px",
                        }}
                      >
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>



              </div> </div>



            {hasEconomic && (
              <section className="report-section section-economic" style={{ marginTop: 20 }}>
                <div className="section-head">
                  <div className="section-head-title">
                    {/* <span className="section-icon">&#128200;</span> */}
                    <span className="section-icon"><img src="../../images/print-economic.svg" width={30} /></span>
                    <div>
                      <div className="sh-name">ECONOMIC</div>
                      <div className="sh-desc"> Driving Growth</div>
                    </div>
                  </div>
                  <SummaryStrip summary={{
                    totalIndicators: computeStats("Economic").total || 0,
                    averageScore: printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Economic")[0]?.averagescore || 0,
                    highestScore: computeStats("Economic").max != null ? computeStats("Economic").max.toFixed(2) + "%" : "-",
                    lowestScore: computeStats("Economic").min != null ? computeStats("Economic").min.toFixed(2) + "%" : "-",
                    activeIndicators: computeStats("Economic").activeIndicators || 0,
                    inactiveIndicators: computeStats("Economic").inactiveIndicators || 0,
                    onTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Economic" && item.grade === "A+").length, },
                    aboveTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Economic" && item.grade === "A").length, pct: "22.22%" },
                    belowTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Economic" && item.grade === "B").length, pct: "0%" },
                    aspTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Economic" && item.grade === "C").length, pct: "0%" },
                    averageAchievements: "100%",
                    // averageAchievements: "82.96%",
                  }} accent="#f07d00" gaugeColor="#f07d00" />
                </div>
                <div className="dashboardtable-wrap"> {renderPrintSection("Economic", printData?.indicatorData)} </div>
                {isApprovalView && renderSectionRemarks("Economic", economicRemarks, setEconomicRemarks)}
                {!isApprovalView && renderSavedSectionRemark("Economic", printData?.eco_remarks || parseCombinedRemarks(printData?.remarks).economic)}
              </section>)}

            {hasSocial && (
              <section className="report-section section-social">
                <div className="section-head">
                  <div className="section-head-title">
                    {/* <span className="section-icon">&#128101;</span> */}
                    <span className="section-icon"><img src="../../images/print-social.svg" width={30} /></span>
                    <div>
                      <div className="sh-name">SOCIAL</div>
                      <div className="sh-desc"> Improving Quality of Life</div>
                    </div>
                  </div>
                  <SummaryStrip summary={{
                    totalIndicators: computeStats("Social").total || 0,
                    averageScore: printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Social")[0]?.averagescore || 0,
                    highestScore: computeStats("Social").max != null ? computeStats("Social").max.toFixed(2) + "%" : "-",
                    lowestScore: computeStats("Social").min != null ? computeStats("Social").min.toFixed(2) + "%" : "-",
                    activeIndicators: computeStats("Social").activeIndicators || 0,
                    inactiveIndicators: computeStats("Social").inactiveIndicators || 0,
                    onTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Social" && item.grade === "A+").length, },
                    aboveTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Social" && item.grade === "A").length, pct: "22.22%" },
                    belowTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Social" && item.grade === "B").length, pct: "0%" },
                    aspTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Social" && item.grade === "C").length, pct: "0%" },
                    averageAchievements: "100%",
                    // averageAchievements: "82.96%",
                  }} accent="#2e9e3a" gaugeColor="#2e9e3a" />
                </div>
                <div className="dashboardtable-wrap"> {renderPrintSection("Social", printData?.indicatorData)} </div>
                {isApprovalView && renderSectionRemarks("Social", socialRemarks, setSocialRemarks)}
                {!isApprovalView && renderSavedSectionRemark("Social", printData?.soc_remarks || parseCombinedRemarks(printData?.remarks).social)}
              </section>)}

            {hasGovernance && (
              <section className="report-section section-governance">
                <div className="section-head">
                  <div className="section-head-title">
                    {/* <span className="section-icon">&#127963;</span> */}
                    <span className="section-icon"><img src="../../images/print-governance.svg" width={30} /></span>
                    <div>
                      <div className="sh-name">GOVERNANCE</div>
                      <div className="sh-desc"> Strengthening Service Delivery </div>
                    </div>
                  </div>
                  <SummaryStrip summary={{
                    totalIndicators: computeStats("Governance").total || 0,
                    averageScore: printData?.criteriaData?.filter((d) => d.cs_indicator_type === "Governance")[0]?.averagescore || 0,
                    highestScore: computeStats("Governance").max != null ? computeStats("Governance").max.toFixed(2) + "%" : "-",
                    lowestScore: computeStats("Governance").min != null ? computeStats("Governance").min.toFixed(2) + "%" : "-",
                    activeIndicators: computeStats("Governance").activeIndicators || 0,
                    inactiveIndicators: computeStats("Governance").inactiveIndicators || 0,
                    onTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Governance" && item.grade === "A+").length, },
                    aboveTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Governance" && item.grade === "A").length, pct: "22.22%" },
                    belowTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Governance" && item.grade === "B").length, pct: "0%" },
                    aspTarget: { value: (printData?.indicatorData || []).filter((item) => item.cs_indicator_type === "Governance" && item.grade === "C").length, pct: "0%" },
                    averageAchievements: "100%",
                    // averageAchievements: "82.96%",
                  }} accent="#1f6fe0" gaugeColor="#1f6fe0" />
                </div>
                <div className="dashboardtable-wrap">
                  {renderPrintSection("Governance", printData?.indicatorData)}</div>
                {isApprovalView && renderSectionRemarks("Governance", governanceRemarks, setGovernanceRemarks)}
                {!isApprovalView && renderSavedSectionRemark("Governance", printData?.gov_remarks || parseCombinedRemarks(printData?.remarks).governance)}
              </section>)}

            {formik.values.type !== "const" && barData.length > 0 && (
              <div className="approval-bar-chart mb-2" style={{ width: "100%", height: "500px", border: "1px solid #ccc", background: "#fff" }}>
                <ResponsiveContainer width="83%" height="100%">
                  <BarChart data={barData} layout="vertical" margin={{
                    top: 20,
                    left: 0,
                    bottom: 10,
                    right: 10
                  }} barCategoryGap="25%" >
                    <XAxis
                      type="number"
                      domain={[0, 100]}
                      ticks={[0, 20, 40, 60, 80, 100]}
                      allowDataOverflow={false}
                      tick={{ fontSize: 9, fontWeight: "bold", fill: "#000", }}
                      label={{
                        value: `Score (${monthLabel} ${selectedYear})`,
                        position: "insideBottom",
                        offset: -8,
                        fill: "#000",
                        fontSize: 9
                      }}
                    />


                    <YAxis
                      type="category"
                      dataKey="district_name"
                      width={190}
                      interval={0}
                      tick={({ x, y, payload }) => {
                        const entry = barData.find((item) => {
                          const selectedId =
                            formik.values.type === "mandal"
                              ? printScoreObj?.mandal_id
                              : printScoreObj?.district_id;

                          return (
                            String(item.district_id) === String(selectedId) &&
                            item.district_name === payload.value
                          );
                        });

                        return (
                          <text
                            x={x - 10}
                            y={y}
                            textAnchor="end"
                            dominantBaseline="middle"
                            fontSize={9}
                            fontWeight="bold"
                            fill={entry ? getBarColor(entry.grade) : "#000"}
                          >
                            {payload.value}
                          </text>
                        );
                      }}
                    />

                    <Tooltip
                      formatter={(value) => [
                        Number(value),
                        "Score",
                      ]}
                      labelFormatter={(label) =>
                        `District: ${label}`
                      }
                    />

                    <Bar
                      dataKey="average_score"
                      name="Average Score"
                      barSize={10}
                      shape={(props) => {
                        const entry = barData[props.index];
                        return (
                          <rect
                            x={props.x}
                            y={props.y}
                            width={props.width}
                            height={props.height}
                            fill={getBarColor(entry?.grade)}
                          />
                        );
                      }}
                    >


                      <LabelList
                        dataKey="average_score"
                        position="right"
                        offset={8}
                        fill="#000"
                        fontSize={8}
                        fontWeight="bold"
                        formatter={(value) => Number(value)}
                      />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            )}

            {descTime && (
              <Alert className="approval-disclaimer py-2 px-3 mb-2 mt-2" style={{ fontSize: "12px", backgroundColor: "#fdecec", borderColor: "#f5b5b5", color: "#a00000", }} >
                <strong>Disclaimer:</strong> This report was generated based on the data
                available in the portal on <strong>{descTime}</strong>.
              </Alert>
            )}
            {/* </div> */}
          </div>

          {isApprovalView && (
            <div style={{ marginTop: 10 }}>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "12px" }}>
                <button
                  type="button"
                  onClick={closeApprovalView}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={handleApprove}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#28a745",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Approve
                </button>
              </div>
            </div>
          )}
        </div>

        <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
      </Container>
    </>
  );
};

export default CriteriaScorecardReport;
